module.exports = __webpack_public_path__ + "static/media/reactlogo.9b864b36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reactlogo.png
// module id = 1775
// module chunks = 0